import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
`

export const RadioContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const RadioButtonTextWrapper = styled.div`
  flex: 1;
`

// TODO: Remover componente abaixo após resolução do fluxo de remarcação total da reserva
export const PlaceholderRadioButton = styled.div`
  border: 1px dashed #A7A7A7;
  background: #F5F5F5;
  border-radius: 5px;
  padding: 15px 20px;
  width: 100%;
  cursor: not-allowed;
  
  .placeholderText {
    color: #C1C1C1;
  }
`